(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oso-bowl-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oso-category-gallery')) {
  class OsoCategoryGallery extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.oso-gallery__card'));
      this.grid = this.querySelector('.oso-gallery__grid');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateMotion();
        });
      };
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.reduced.addEventListener('change', this.schedule);
      this.addEventListener('focusin', this.schedule);
      this.addEventListener('focusout', this.schedule);
      this.schedule();
    }
    updateMotion() {
      if (!this.grid) return;
      const disabled = this.dataset.motion === 'false' || this.reduced.matches || this.contains(document.activeElement);
      const viewport = window.innerHeight;
      const mobile = window.innerWidth < 750;
      const top = this.grid.getBoundingClientRect().top;
      this.cards.forEach((card, index) => {
        const naturalTop = top + card.offsetTop;
        const progress = disabled ? 1 : Math.min(1, Math.max(0, (viewport * .96 - naturalTop) / (viewport * .66)));
        const remaining = 1 - progress * progress * (3 - 2 * progress);
        const lift = mobile ? 48 : 135 + index * 50;
        card.style.setProperty('--oso-y', (remaining * lift).toFixed(2) + 'px');
        card.style.setProperty('--oso-x', (mobile ? 0 : remaining * (1 - index) * 105).toFixed(2) + 'px');
        card.style.setProperty('--oso-card-scale', (1 - remaining * (mobile ? .02 : .07)).toFixed(4));
        card.style.setProperty('--oso-scale', (1 + remaining * .03).toFixed(4));
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.reduced.removeEventListener('change', this.schedule);
      this.removeEventListener('focusin', this.schedule);
      this.removeEventListener('focusout', this.schedule);
    }
  }
  customElements.define('oso-category-gallery', OsoCategoryGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oso-editorial-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', function(event) {
  if (event.target.matches('.oso-story__film') && !event.target.open) {
    event.target.querySelectorAll('video').forEach(function(video) { video.pause(); });
  }
}, true);

  } catch(e) { console.error(e); }
})();
})();
